import React, { Fragment } from 'react';
import ryanair from 'components/assets/img/logo/ryanair.svg';
import wizzair from 'components/assets/img/logo/wizzair.png';
import airFrance from 'components/assets/img/logo/air_france.png';
import australian from 'components/assets/img/logo/australian.png';
import britishAirways from 'components/assets/img/logo/british_airways.png';
import klmDutch from 'components/assets/img/logo/klm_dutch.png';
import lot from 'components/assets/img/logo/lot.png';
import lufthansa from 'components/assets/img/logo/lufthansa.png';
import norwegian from 'components/assets/img/logo/norwegian.png';
import sas from 'components/assets/img/logo/sas.png';
import swiss from 'components/assets/img/logo/swiss.png';

import airplane from 'components/assets/img/icons/airplane.svg';
import moment from 'moment';
import {
  DIRECTION_ARRIVE, DIRECTION_FLIGHT,
  CARRIER_RYANAIR, CARRIER_WIZZAIR,
  CARRIER_NORWEGIAN,
  CARRIER_LOT,
  CARRIER_LUFTHANSA,
  CARRIER_BRITISH_AIRWAYS,
  CARRIER_AIR_FRANCE,
  CARRIER_KLM_ROYAL_DUTCH_AIRLINES,
  CARRIER_SWISS_INTERNATIONAL_AIR_L,
  CARRIER_AUSTRIAN_AIRLINES,
  CARRIER_SAS_SCANDINAVIAN_AIRLINES
} from 'components/components/booking/utils/FlightConstants';

function formatDuration(duration) {
  var minutes = duration.minutes();
  var hours = duration.hours();
  var text = '';
  if (hours > 0) {
    text += hours + "h ";
  }
  text += minutes + "min";
  return text;
}

function handleOnClick(e, flight, handler) {
  e.preventDefault();
  if (flight.is_blocked_in_pwa) {
    return false;
  } else {
    handler(flight);
  }
}

function returnCarrierImg(carrierType) {
  let image = null;
  let alt = '';
  let imgStyles = { height: 'auto' };

  switch (carrierType) {
    case CARRIER_RYANAIR:
      image = ryanair;
      alt = 'Ryanair';
      break;
    case CARRIER_WIZZAIR:
      imgStyles = { width: '30px' };
      image = wizzair;
      alt = 'Wizz Air';
      break;
    case CARRIER_NORWEGIAN:
      image = norwegian;
      alt = 'Norwegian';
      break;
    case CARRIER_LOT:
      image = lot;
      alt = 'LOT';
      break;
    case CARRIER_LUFTHANSA:
      image = lufthansa;
      alt = 'Lufthansa';
      break;
    case CARRIER_BRITISH_AIRWAYS:
      image = britishAirways;
      alt = 'British Airways';
      break;
    case CARRIER_AIR_FRANCE:
      image = airFrance;
      alt = 'Air France';
      break;
    case CARRIER_KLM_ROYAL_DUTCH_AIRLINES:
      image = klmDutch;
      alt = 'KLM';
      break;
    case CARRIER_SWISS_INTERNATIONAL_AIR_L:
      image = swiss;
      alt = 'Swiss';
      break;
    case CARRIER_AUSTRIAN_AIRLINES:
      image = australian;
      alt = 'Austrian Airlines';
      break;
    case CARRIER_SAS_SCANDINAVIAN_AIRLINES:
      image = sas;
      alt = 'SAS';
      break;
    default:
      return null;
  }

  return (
    <img
      alt={alt}
      src={image}
      style={imgStyles}
    />
  );

}

function ItemFlight(props) {
  var flight = props.flightObj;
  var dateMoment = moment(flight.flight_date);
  var dateFormated = dateMoment.format("DD.MM.YYYY");
  var dateHoursFormated = dateMoment.format("HH:mm");
  if (flight.flight_mirror_date) {
    var isMirrorDate = true;
    var mirrorDateMoment = moment(flight.flight_mirror_date);
    var mirrorDateHours = mirrorDateMoment.format("HH:mm");
  } else {
    var isMirrorDate = false;
    var mirrorDateHours = '';
  }

  if (flight.direction === DIRECTION_FLIGHT) {
    //from oslo to city
    var departure = flight.airport.name;
    var arrival = flight.city.name;
    //mirrorDate - date
    if (isMirrorDate) {
      var duration = moment.duration(mirrorDateMoment.diff(dateMoment));
    }
  } else {
    var departure = flight.city.name;
    var arrival = flight.airport.name;
    //date - mirrorDate
    if (isMirrorDate) {
      var duration = moment.duration(dateMoment.diff(mirrorDateMoment));
    }
  }
  var formattedDuration = isMirrorDate ? formatDuration(duration) : '';

  var cssClass = 'list-flights__item';
  if (flight.is_blocked_in_pwa) {
    cssClass = 'list-flights__item list-flights__item--blocked';
  } else if (props.active) {
    cssClass = 'list-flights__item list-flights__item--active';
  }

  return (
    <li className={cssClass} onClick={(e) => handleOnClick(e, flight, props.handleChange)}>
      <div className="list-flights__header">
        <p>{dateFormated}</p>
        <div>
          {returnCarrierImg(flight.carrier_type)}
        </div>
      </div>

      <div className="list-flights__flight-time">
        <p>{formattedDuration}&nbsp;</p>
      </div>

      <div className="list-flights__desc">
        <div className="list-flights__departure">
          <p className="list-flights__time">
            {
              flight.direction === DIRECTION_FLIGHT
                ?
                dateHoursFormated
                :
                mirrorDateHours
            }
          </p>
          <p>{departure}</p>
        </div>

        <div className="list-flights__icon">
          <span>
            <img src={airplane} />
          </span>
        </div>

        <div className="list-flights__arrival">
          <p className="list-flights__time">
            {
              flight.direction === DIRECTION_ARRIVE
                ?
                dateHoursFormated
                :
                mirrorDateHours
            }
          </p>
          <p>{arrival}</p>
        </div>
      </div>
    </li>
  );
}

export default ItemFlight;
